import { type ElementType, type ReactNode } from 'react'

interface Props {
  children: ReactNode
  tooltip: ElementType
}

const BadgeTooltip = ({ children, tooltip: Tooltip }: Props) => {
  if (!Tooltip) {
    return <>{children}</>
  }

  return <Tooltip>{children}</Tooltip>
}

export default BadgeTooltip
